import React, { useState, useEffect, useRef } from 'react';
import ILoveSG from '../assets/ILoveSG.png';
import langflon from '../assets/langflon.png';
import klubbmix from '../assets/klubbmix.png';

const About: React.FC = () => {
  // Album data
  const albums = [
    {
      id: 1,
      title: "I <3 smuglergods",
      image: ILoveSG,
      year: "2024"
    },
    {
      id: 2,
      title: "elverum - långflon smuglerrute",
      image: langflon,
      year: "2022"
    },
    {
      id: 3,
      title: "100% smuglermix",
      image: klubbmix,
      year: "2022"
    },
    // Placeholder albums
    {
      id: 4,
      title: "Kommende slipp",
      image: null,
      year: "2025"
    },
    {
      id: 5,
      title: "Live i Trondheim",
      image: null,
      year: "2023"
    },
    {
      id: 6,
      title: "Sjeldne spor",
      image: null,
      year: "2023"
    },
    {
      id: 7,
      title: "Remixsamling",
      image: null,
      year: "2022"
    }
  ];

  // For carousel functionality
  const carouselRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  
  // Auto scroll effect with seamless looping
  useEffect(() => {
    if (!carouselRef.current) return;
    
    // Calculate width of a single item (card + margin)
    const itemWidth = 320 + 24; // width + margin
    const totalItems = albums.length;
    
    // Clone first items and append to the end for seamless loop
    const carousel = carouselRef.current;
    
    let currentPosition = 0;
    let animationFrameId: number;
    
    const animate = () => {
      if (isPaused) {
        animationFrameId = requestAnimationFrame(animate);
        return;
      }
      
      // Very slow movement (0.5 pixels per frame)
      currentPosition += 0.5;
      
      // If we've scrolled past an item, check if we need to loop
      if (currentPosition >= totalItems * itemWidth) {
        // Loop back to start (immediately, no animation)
        currentPosition = 0;
        carousel.scrollLeft = 0;
      } else {
        carousel.scrollLeft = currentPosition;
      }
      
      animationFrameId = requestAnimationFrame(animate);
    };
    
    animationFrameId = requestAnimationFrame(animate);
    
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [isPaused, albums.length]);

  const handleCarouselHover = (isHovering: boolean) => {
    setIsPaused(isHovering);
  };

  const handleAlbumClick = (id: number) => {
    console.log(`Album ${id} clicked`);
    // Here you could implement additional functionality like opening a modal with album details
  };

  return (
    <div className="bg-[#080808] text-white py-16">
      <div className="container mx-auto px-4">
        <h1 className="text-5xl font-bold mb-12 text-center tracking-tight" style={{ color: '#9bf01e' }}>Om Smuglergods</h1>
        
        {/* Band Image Section */}
        <div className="mb-16 flex justify-center">
          <div className="w-full max-w-4xl h-96 flex items-center justify-center" style={{ background: 'rgba(155,240,30,0.03)', border: '1px solid rgba(155,240,30,0.15)' }}>
            <p className="text-lg text-gray-400">Plassholder for bandbilde</p>
          </div>
        </div>
        
        {/* Bio Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-20">
          <div>
            <h2 className="text-2xl font-bold mb-6 tracking-tight" style={{ color: '#9bf01e' }}>Vår historie</h2>
            <p className="text-base mb-4 leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce vitae nisi euismod, 
              feugiat lorem vel, vehicula nunc. Nullam sagittis, felis vel tincidunt cursus, 
              nibh massa ultrices sapien, id gravida ipsum turpis quis eros.
            </p>
            <p className="text-base mb-4 leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
              Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta 
              sem malesuada magna mollis euismod. Cras mattis consectetur purus sit amet fermentum. 
              Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
            </p>
          </div>
          <div className="h-80 flex items-center justify-center" style={{ background: 'rgba(155,240,30,0.03)', border: '1px solid rgba(155,240,30,0.15)' }}>
            <p className="text-lg text-gray-400">Plassholder for bandmedlem-bilde</p>
          </div>
        </div>
        
        {/* Music Style Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-20">
          <div className="order-2 md:order-1 h-80 flex items-center justify-center" style={{ background: 'rgba(155,240,30,0.03)', border: '1px solid rgba(155,240,30,0.15)' }}>
            <p className="text-lg text-gray-400">Plassholder for scenebilde</p>
          </div>
          <div className="order-1 md:order-2">
            <h2 className="text-2xl font-bold mb-6 tracking-tight" style={{ color: '#9bf01e' }}>Vår lyd</h2>
            <p className="text-base mb-4 leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
              Vestibulum id ligula porta felis euismod semper. Etiam porta sem malesuada magna 
              mollis euismod. Donec id elit non mi porta gravida at eget metus. Cras justo odio, 
              dapibus ac facilisis in, egestas eget quam.
            </p>
            <p className="text-base mb-4 leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
              Nullam quis risus eget urna mollis ornare vel eu leo. Sed posuere consectetur est 
              at lobortis. Cras mattis consectetur purus sit amet fermentum.
            </p>
          </div>
        </div>
        
        {/* Band Members Section */}
        <div className="mb-20">
          <h2 className="text-2xl font-bold mb-12 text-center tracking-tight" style={{ color: '#9bf01e' }}>Møt Smuglerne</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[1, 2, 3, 4].map((member) => (
              <div key={member} className="flex flex-col items-center">
                <div className="w-full aspect-square mb-4 flex items-center justify-center" style={{ background: 'rgba(155,240,30,0.03)', border: '1px solid rgba(155,240,30,0.15)' }}>
                  <p className="text-lg text-gray-400">Medlem {member} bilde</p>
                </div>
                <h3 className="text-lg font-bold text-white mb-1">Smugler {member}</h3>
                <p className="text-xs tracking-wide mb-2" style={{ color: '#9bf01e', opacity: 0.8 }}>Rolle / instrument</p>
                <p className="text-center text-sm" style={{ color: 'rgba(255,255,255,0.45)' }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce vitae nisi euismod.
                </p>
              </div>
            ))}
          </div>
        </div>
        
        {/* Auto-scrolling Album Carousel with seamless looping */}
        <div className="mb-20">
          <h2 className="text-2xl font-bold mb-8 text-center tracking-tight" style={{ color: '#9bf01e' }}>Diskografi</h2>
          <p className="text-center text-gray-400 mb-6">Hold musepekeren over for å pause karusellen</p>
          
          <div className="relative overflow-hidden">
            <div 
              ref={carouselRef}
              className="flex overflow-x-auto scrollbar-hide"
              style={{ 
                WebkitOverflowScrolling: 'touch',
                msOverflowStyle: 'none',
                scrollbarWidth: 'none'
              }}
              onMouseEnter={() => handleCarouselHover(true)}
              onMouseLeave={() => handleCarouselHover(false)}
            >
              <div className="flex space-x-6 px-4">
                {/* Display regular albums first */}
                {albums.map(album => (
                  <div 
                    key={album.id} 
                    className="flex-shrink-0 w-80"
                    onClick={() => handleAlbumClick(album.id)}
                  >
                    <div className="w-full aspect-square mb-4 overflow-hidden" style={{ background: 'rgba(255,255,255,0.04)' }}>
                      {album.image ? (
                        <img 
                          src={album.image} 
                          alt={album.title} 
                          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center" style={{ background: 'rgba(255,255,255,0.04)' }}>
                          <div className="text-center p-4">
                            <p className="text-white text-sm font-bold opacity-60">{album.title}</p>
                            <p className="text-gray-400 text-sm">Kommer snart</p>
                          </div>
                        </div>
                      )}
                    </div>
                    <h3 className="text-base font-bold text-white truncate">{album.title}</h3>
                    <p className="text-xs mb-1" style={{ color: '#9bf01e', opacity: 0.7 }}>Utgitt: {album.year}</p>
                    <p className="text-xs line-clamp-2" style={{ color: 'rgba(255,255,255,0.4)' }}>
                      {album.image ? 
                        "Nullam quis risus eget urna mollis ornare vel eu leo." : 
                        "Kommende slipp - følg med for mer informasjon!"}
                    </p>
                  </div>
                ))}
                
                {/* Clone first album for seamless looping */}
                <div 
                  key="loop-clone" 
                  className="flex-shrink-0 w-80"
                  onClick={() => handleAlbumClick(albums[0].id)}
                >
                  <div className="w-full aspect-square mb-4 overflow-hidden" style={{ background: 'rgba(255,255,255,0.04)' }}>
                    {albums[0].image ? (
                      <img 
                        src={albums[0].image}
                        alt={albums[0].title} 
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center" style={{ background: 'rgba(255,255,255,0.04)' }}>
                        <div className="text-center p-4">
                          <p className="text-white text-sm font-bold opacity-60">{albums[0].title}</p>
                          <p className="text-gray-400 text-sm">Kommer snart</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <h3 className="text-base font-bold text-white truncate">{albums[0].title}</h3>
                  <p className="text-xs mb-1" style={{ color: '#9bf01e', opacity: 0.7 }}>Utgitt: {albums[0].year}</p>
                  <p className="text-xs line-clamp-2" style={{ color: 'rgba(255,255,255,0.4)' }}>
                    {albums[0].image ? 
                      "Nullam quis risus eget urna mollis ornare vel eu leo." : 
                      "Kommende slipp - følg med for mer informasjon!"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// CSS for hiding scrollbar
const styles = document.createElement('style');
styles.textContent = `
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
`;
document.head.appendChild(styles);

export default About; 